import { createContext } from 'react'

import { ApiService } from './api'
import { BrowserService } from './browser'
import { ExperimentsServiceImpl, ExperimentService } from './experiments'
import { FacadeService } from './facade'
import { UserService } from './user'
import { SubscriptionServiceImpl, SubscriptionService } from '@lib/services/subscription'
import { UserJourneyService, UserJourneyServiceImpl } from './user-journey'
import { NinetailedPersonalizationService, NinetailedPersonalizationServiceImpl } from './ninetailed-personalization'
import { LocalizedPricesIndiaService, LocalizedPricesIndiaServiceImpl } from './localized-prices-india'
import { GeoLocationService } from './geo-location'

export interface CommonServices {
  readonly facadeService: FacadeService
  readonly browserService: BrowserService
  readonly userService: UserService
  readonly experimentService: ExperimentService
  readonly subscriptionService: SubscriptionService
  readonly userJourneyService: UserJourneyService
  readonly ninetailedPersonalizationService: NinetailedPersonalizationService
  readonly localizedPricesIndiaService: LocalizedPricesIndiaService
  readonly geoLocationService: GeoLocationService
}

export const createCommonServices = (apiService: ApiService, facadeFactory: () => FacadeService): CommonServices => {
  const facadeService = facadeFactory()
  const browserService = new BrowserService(facadeService)
  const userService = new UserService(apiService.auth, facadeService)
  const geoLocationService = new GeoLocationService(facadeService)
  const experimentService = new ExperimentsServiceImpl(
    fetch,
    facadeService,
    userService,
    geoLocationService,
    browserService
  )
  const subscriptionService = new SubscriptionServiceImpl(facadeService)
  const userJourneyService = new UserJourneyServiceImpl(userService, browserService)
  const ninetailedPersonalizationService = new NinetailedPersonalizationServiceImpl(facadeService)
  const localizedPricesIndiaService = new LocalizedPricesIndiaServiceImpl(experimentService, geoLocationService)

  return {
    facadeService,
    browserService,
    userService,
    experimentService,
    subscriptionService,
    userJourneyService,
    ninetailedPersonalizationService,
    localizedPricesIndiaService,
    geoLocationService,
  }
}

export const apiService = new ApiService(fetch)

export const CommonServicesContext = createContext({} as CommonServices)
export const ApiServiceContext = createContext(apiService)
